import {
	Divider as DividerMui,
} from '@mui/material';
import { BaseProps, appendClassName } from '@componentLibraryWrapper/common';
import './divider.scss';

export interface DividerProps extends BaseProps<HTMLHRElement> {
	flexItem?: boolean
	orientation?: 'vertical' | 'horizontal',
	variant?: 'fullWidth' | 'inset' | 'middle'
}

const Divider = ({
	className,
	flexItem=false,
	orientation='horizontal',
	variant='fullWidth',
	...rest
}: DividerProps) => {
	return (
		<DividerMui
			{...rest}
			className={appendClassName('sm-divider', className)}
			orientation={orientation}
			variant={variant}
			flexItem={flexItem}/>
	)
}

export default Divider;